export const CERTIFICATE_MAILING_ACTION_TYPES = {
	ARCHIVE: 'Archive',
	MAILING: 'Mailing',
};

export const certificateMailingActionTypesText = {
	[CERTIFICATE_MAILING_ACTION_TYPES.ARCHIVE]: 'Сформировать архив',
	[CERTIFICATE_MAILING_ACTION_TYPES.MAILING]: 'Отправить застрахованным на e-mail',
};

export const certificateMailingActionTypes = [
	CERTIFICATE_MAILING_ACTION_TYPES.ARCHIVE,
	CERTIFICATE_MAILING_ACTION_TYPES.MAILING,
];
